const prod_URL = process.env.REACT_APP_API_URL


export const API_URLS = {
    // ------------------- Login API ------------------------------- //

   LoginApi: `${prod_URL}/auth/login`,
   userroledetails: `${prod_URL}/users/collector/details`,
   
    // ---------------------- Super Admin APIs -------------------------- //

    InsertMunicipality: `${prod_URL}/insert-municipalty`,
    MunicipalityList: `${prod_URL}/municipalty-listing`,
    MunicipalityDetails: `${prod_URL}/fetch-municipality-profile-information`,
    insertPropertyDescription: `${prod_URL}/insert-property-description`,
    PropertyDescriptionList: `${prod_URL}/get-property-description`,
    PropertyTypeList: `${prod_URL}/get-property-type`,
    PropertyTypeDescriptionList: `${prod_URL}/get-property-type-description-info`,
    PurposeOfUsePropertyList: `${prod_URL}/get-porpose-of-use`,
    UseOfPropertyList: `${prod_URL}/get-use-of-property`,
    OccupancyTypeList: `${prod_URL}/get-occpancy-type`,
    PropertyStructure: `${prod_URL}/get-property-floor-roof-wall-type`,
    addpropertyType: `${prod_URL}/add-property-type`,
    addpropertyTypeDescription: `${prod_URL}/insert-property-type-description`,
    addpurposeOfProperty: `${prod_URL}/insert-purpose-of-use-property`,
    addUseOfProperty: `${prod_URL}/insert-use-of-property`,
    addOccupancyType: `${prod_URL}/occupancy-type`,
    addPropertyStrunture: `${prod_URL}/add-property-structure`,

    // ------ Super Admin Mapping APIs  --------- //
    PropertyTypeWiseTypeDescription: `${prod_URL}/fetch-property-type-description-id-wise`,
    TypeDescriptionWiseUseOfProperty: `${prod_URL}/fetch-property-use-of-property-descriptionid-wise`,
    TypeDescriptionWisePurposeOfProperty: `${prod_URL}/fetch-purpose-of-use-by-useofPropertyId-wise`,



    // ------ Super Admin Update APIs  --------- //

    PropertyTypeUpdate: `${prod_URL}/update-property-type`,
    PropertyTypeDescriptionUpdate: `${prod_URL}/update-property-type-description`,
    UseOfPropertyUpdate: `${prod_URL}/update-use-of-property`,
    PurposeOfPropertyUpdate: `${prod_URL}/update-pourpose-of-use`,
    PropertyDescriptionUpdate: `${prod_URL}/update-property-description`,


    // Common APIs for Super Admin & Municipality //

    MunicipalityProfileUpdate: `${prod_URL}/municipalty-profile-update`,
    AddSurveyor: `${prod_URL}/insert-surveyer`,
    ListSurveyor: `${prod_URL}/surveyer-listing`,
    UpdateSurveyor: `${prod_URL}/update-surveyor`,



    // Municipality API //

    GetMunicipalityBorough: `${prod_URL}/municipalty-borough`,
    addBorough: `${prod_URL}/municipalty-add-borough`,
    addWard: `${prod_URL}/municipalty-add-word`,
    addStreet: `${prod_URL}/municipalty-add-street`,
    municipalityHoldingList: `${prod_URL}/municipalty-holding-list`,
    wardList: `${prod_URL}/municipalty-word-list`,
    streetList: `${prod_URL}/municipalty-street-list`,
    locationsList: `${prod_URL}/municipalty-property-location`,
    addLocations: `${prod_URL}/municipalty-add-property-location`,
    FetchSurveyData: `${prod_URL}/assign-holdings-report`,
    GetSurveyReport: `${prod_URL}/surveyer-collect-survey-report`,
    GetCommonSurveyData: `${prod_URL}/surveyor-fetch-common-holding-record`,



    // ------ Municipality Mapping APIs  --------- //

    GetBoroughWiseWard: `${prod_URL}/municipalty-wards-borough-wise`,
    GetWardWiseStreet: `${prod_URL}/municipalty-street-word-wise`,
    GetStreetWiseHoldingNo: `${prod_URL}/municipalty-street-wise-holding-list`,
    wardBoroughWise: `${prod_URL}/municipalty-wards-borough-wise`,
    streetWordWise: `${prod_URL}/municipalty-street-word-wise`,
    WardWiseLocation: `${prod_URL}/municipalty-location-ward-wise`,


    // ------ Municipality Update APIs  --------- //

    BoroughUpdate: `${prod_URL}/update-municipality-borough`,
    WardUpdate: `${prod_URL}/update-municipality-word`,
    StreetUpdate: `${prod_URL}/update-municipality-street`,
    HoldingUpdate: `${prod_URL}/update-municipality-holding`,
    locationUpdate: `${prod_URL}/update-municipality-property-location`,



    // Municipality : - Bulk Upload //

    BulkHoldingData: `${prod_URL}/upload-bulk-holding-data`,
    BulkBoroughData: `${prod_URL}/upload-bulk-borough-data`,
    BulkWardData: `${prod_URL}/upload-bulk-ward-data`,
    BulkStreetData: `${prod_URL}/upload-bulk-street-data`,
    BulkLocationData: `${prod_URL}/upload-bulk-location-data`,




    // Dashboard //

    MunicipalityCount: `${prod_URL}/count-municipality`,
    SurveyorCount: `${prod_URL}/count-surveyor`,

    // Status Change //

    PropertydescriptionStatus: `${prod_URL}/update-property-description-status`,
    PropertyTypedescriptionStatus: `${prod_URL}/update-property-type_description-status`,
    UseOfPropertyStatus: `${prod_URL}/update-use-of-property-status`,
    PropertyTypeStatus: `${prod_URL}/update-property-type-status`,
    PurposeOfPropertyStatus: `${prod_URL}/update-pourpose-of-use-status`,
    SurveyorStatus: `${prod_URL}/update-surveyor-status`,

    // Water supply consumer listing

    consumerCreate: `${prod_URL}/water-connection/create`,
    consumerListing: `${prod_URL}/water-connection/`,
    consumercatagoryapi: `${prod_URL}/consumer-category/get` ,
    usercollector: `${prod_URL}/users/role`,
    usercashier: `${prod_URL}/users/role`,
    
    
    farralListingapi: `${prod_URL}/rate-category/get`,

    // Collector details
    collectordetails: `${prod_URL}/users/collector/details`,
    collectormapping: `${prod_URL}/consumer-transaction-mapping/add`,
    collectorMappedList: `${prod_URL}/consumer-transaction-mapping/get`,

    // cashier
    // cashierList:
    despost: `${prod_URL}/deposit-against-collector/add`,
    collectordepostlisting: `${prod_URL}/deposit-against-collector/get`,
    cashierdeposit: `${prod_URL}/deposit-against-collector/summary`,
    updateCashierandcollector: `${prod_URL}/users/update`,

    // municipalty admin
    customerLedger: `${prod_URL}/water-connection/ledger`,
    customerLedgerTimeline: `${prod_URL}/water-connection/ledger-timeline`,
    collectorReport: `${prod_URL}/users/field-collector/report`,
    mouzafetch: `${prod_URL}/mouza/get`,



    // Admin
    summary: `${prod_URL}/summary`,
    roleType: `${prod_URL}/role`,
    collectorcreate: `${prod_URL}/users/create`,

    // demo csv
    csvdownlaod: `${prod_URL}/water-connection/download`,
    uploadcsv: `${prod_URL}/water-connection/import`,
    uploadcsvFailed: `${prod_URL}/error-logger`,
    uploadcsvhistory: `${prod_URL}/upload/csv-history`,

    consumerToggleStatus: `${prod_URL}/water-connection/change-status`,
    consumerDetail: `${prod_URL}/water-connection/get`,
    consumerUpdate: `${prod_URL}/water-connection/update`,

    // mouza crud
    createmouza: `${prod_URL}/mouza/create`,
    BulkMouzaData: `${prod_URL}/mouza/bulk-upload`,
    mouzalisting: `${prod_URL}/mouza/get`,
    updatemouza: `${prod_URL}/mouza/update`,
    deletemouza: `${prod_URL}/mouza/delete`,

    DemandDraftGenerateapi: `${prod_URL}/water-connection-bill/demand-draft`,
    DemandDraftStatusapi: `${prod_URL}/water-connection-bill/demand-draft/status`,
    DemandDraftDownloadapi: `${prod_URL}/water-connection-bill/demand-draft/download`,

    // Customer legerd
    generateSignalReport: `${prod_URL}/water-connection/wardwise-register`,
    generateStatusApi: `${prod_URL}/water-connection/wardwise-register/status`,
    downloadApiReport:`${prod_URL}/water-connection/wardwise-register/download`

};




